import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

/** Banner chỉ ủy quyền cho App — không tự ghi cookie (tránh double-write / race) */
const Cookies = ({ onAcceptAll, onRejectAll, onPreferences }) => {
  const { t } = useTranslation();

  return (
    <div
      className="
    sticky bottom-0 left-0 right-0 z-50
    p-[1%]
    backdrop-blur-[30px]
    border-t border-white/10
    bg-[#293990]
    items-center justify-center 
  "
    >
      <div className="text-white flex flex-row items-center justify-center md:flex-col gap-4 w-full md:items-center mx-auto">
        <div className="leading-relaxed md:max-w-3xl">
          <p className="font-bold text-[16px]">{t("cookies.title")}</p>
          <p className="mt-1 opacity-90 text-[15px]">
            {t("cookies.description")}
          </p>
        </div>

        <div className="flex flex-row gap-2 sm:flex-row md:flex-col md:w-full  whitespace-nowrap">
          <button
            type="button"
            onClick={onPreferences}
            className="w-[200px] md:w-[100%]
 rounded-md border p-[10px] h-[48px] text-[15px] hover:bg-white/10"
          >
            {t("cookies.preferences")}
          </button>

          <button
            type="button"
            onClick={() =>
              onRejectAll?.({
                functional: false,
                analytics: false,
                marketing: false,
              })
            }
            className="w-[200px] md:w-[100%]
 rounded-md border p-[10px] h-[48px] text-[15px] hover:bg-white/10"
          >
            {t("cookies.rejectAll")}
          </button>

          <button
            type="button"
            onClick={() =>
              onAcceptAll?.({
                functional: true,
                analytics: true,
                marketing: true,
              })
            }
            className="w-[200px] md:w-[100%]
 rounded-md px-5 px-5 p-[10px] h-[48px] text-[15px] font-medium bg-[var(--tree-poppy)] mx-auto items-center justify-center flex "
          >
            {t("cookies.acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
};

Cookies.propTypes = {
  onAcceptAll: PropTypes.func.isRequired,
  onRejectAll: PropTypes.func.isRequired,
  onPreferences: PropTypes.func.isRequired,
};

export default Cookies;
